import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
import { SectionHeader } from './ui/SectionHeader';
const testimonials = [{
  name: 'Tomás M. (Buenos Aires)',
  quote: 'Organice toda mi ensalada mental en un solo fin de semana. Ahora sé exactamente qué hábito está disparando mi ansiedad y cómo cortarlo en 5 minutos. Nunca más volví a vivir el día improvisando o al borde del colapso.'
}, {
  name: 'Ignacio R. (Rosario)',
  quote: 'El enfoque de disciplina emocional lo cambió todo. Logré frenar los bucles de pensamientos destructivos en menos de 2 meses, después de estar un año entero atrapado en rumiación constante. Dormir volvió a ser algo normal.'
}, {
  name: 'Valentina F. (Córdoba)',
  quote: 'Adapto el plan de emergencia mental según cómo me siento en el día. Antes me pasaba horas buscando videos en YouTube o leyendo tips sueltos en Instagram para intentar calmarme sin éxito.'
}];
export function Testimonials() {
  return <section className="py-20 px-6 border-b border-ink/10 bg-bone-dark/30" data-id="element-162">
      <div className="max-w-editorial mx-auto" data-id="element-163">
        <SectionHeader number="01" title="Lo que dicen quienes ya recuperaron el control:" data-id="element-164" />

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-12" data-id="element-165">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-bone border border-ink/10 p-8 rounded-sm relative" data-id="element-166">
              <div className="absolute -top-4 -left-2 text-6xl font-serif text-oxblood/20 leading-none" data-id="element-167">
                "
              </div>
              <div className="flex gap-1 mb-6" data-id="element-168">
                {[...Array(5)].map((_, i) => <Star key={i} size={16} className="text-oxblood fill-oxblood" data-id="element-169" />)}
              </div>
              <p className="text-ink-light font-sans leading-relaxed mb-8 relative z-10" data-id="element-170">
                {testimonial.quote}
              </p>
              <div className="font-serif font-medium text-ink" data-id="element-171">
                — {testimonial.name}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}